import { NgModule } from '@angular/core';
import { NoticeEditComponent } from './notice-edit/notice-edit.component';
import { NoticeListComponent } from './notice-list/notice-list.component';
import { SharedModule } from '../shared/shared.module';
import { NoticeScrollComponent } from './notice-scroll/notice-scroll.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    NoticeListComponent,
    NoticeEditComponent,
    NoticeScrollComponent
  ],
  exports: [
    NoticeListComponent,
    NoticeEditComponent,
    NoticeScrollComponent
  ]
})
export class NoticeModule { }
